import 'ol/ol.css'
import TileLayer from 'ol/layer/Tile'
import TileImage from 'ol/source/TileImage'
import XYZ from 'ol/source/XYZ'
import OSM from 'ol/source/OSM'
import LayerGroup from 'ol/layer/Group'

export const baseLayers = (baseSelected = null) => {
    const activeBaseLayer = baseSelected ?? 'g_road_wo_building'

    return new LayerGroup({
        title: 'Camadas de Base',
        openInLayerSwitcher: false,
        layers: [
            new TileLayer({
                title: 'Open Street Map',
                baseLayer: true,
                visible: activeBaseLayer === 'osm',
                source: new OSM()
            }),
            new TileLayer({
                title: 'Economia de Toner',
                baseLayer: true,
                visible: activeBaseLayer === 'toner',
                source: new XYZ({
                    url: 'https://stamen-tiles.a.ssl.fastly.net/toner/{z}/{x}/{y}.png',
                    attributions: 'Map tiles by Stamen Design, under CC BY 3.0. Data by OpenStreetMap, under ODbL.'
                })
            }),
            new TileLayer({
                title: 'Watercolor',
                baseLayer: true,
                visible: activeBaseLayer === 'watercolor',
                source: new XYZ({
                    url: 'https://stamen-tiles.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg',
                    attributions: 'Map tiles by Stamen Design, under CC BY 3.0. Data by OpenStreetMap, under ODbL.'
                })
            }),
            new TileLayer({
                title: 'Rótulos de terreno',
                baseLayer: true,
                visible: activeBaseLayer === 'terrainLabels',
                source: new XYZ({
                    url: 'https://stamen-tiles.a.ssl.fastly.net/terrain-labels/{z}/{x}/{y}.png',
                    attributions: 'Map tiles by Stamen Design, under CC BY 3.0. Data by OpenStreetMap, under ODbL.'
                })
            }),
            new TileLayer({
                title: 'Terreno',
                baseLayer: true,
                visible: activeBaseLayer === 'terrain',
                source: new XYZ({
                    url: 'https://stamen-tiles.a.ssl.fastly.net/terrain/{z}/{x}/{y}.jpg',
                    attributions: 'Map tiles by Stamen Design, under CC BY 3.0. Data by OpenStreetMap, under ODbL.'
                })
            }),
            new TileLayer({
                title: 'Google Road Map',
                baseLayer: true,
                visible: activeBaseLayer === 'g_road',
                source: new TileImage({
                    url: 'http://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}'
                })
            }),
            new TileLayer({
                title: 'Google Satellite',
                baseLayer: true,
                visible: activeBaseLayer === 'g_sat',
                source: new TileImage({
                    url: 'http://mt1.google.com/vt/lyrs=s&hl=pl&&x={x}&y={y}&z={z}'
                })
            }),
            new TileLayer({
                title: 'Google Satellite & Roads',
                baseLayer: true,
                visible: activeBaseLayer === 'g_sat_e_roads',
                source: new TileImage({
                    url: 'http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
                })
            }),
            new TileLayer({
                title: 'Google Terrain',
                baseLayer: true,
                visible: activeBaseLayer === 'g_terrain',
                source: new TileImage({
                    url: 'http://mt1.google.com/vt/lyrs=t&x={x}&y={y}&z={z}'
                })
            }),
            new TileLayer({
                title: 'Google Terrain & Roads',
                baseLayer: true,
                visible: activeBaseLayer === 'g_terrain_e_roads',
                source: new TileImage({
                    url: 'http://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}'
                })
            }),
            new TileLayer({
                title: 'Google Road without Building',
                baseLayer: true,
                visible: activeBaseLayer === 'g_road_wo_building',
                source: new TileImage({
                    url: 'http://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}'
                })
            })
        ]
    })
}
